export interface CareNavigationRespondentContext {
	featureUseRepresentatives: boolean;
	hasSubmission: boolean;
	isRepresenting: boolean;
	preserveSubject: boolean;
	storedNin: string | null;
	urlNin: string | null;
	allowRepresentative: boolean;
	hasRepresentablePatients: boolean;
}

export type RespondentDecision =
	| { kind: 'select' }
	| { kind: 'conflict' }
	| { kind: 'continue'; nin: string | null; preserveDateOfBirth: boolean };

/** Resolve established subjects before considering a new respondent choice. */
export function decideCareNavigationRespondent(context: CareNavigationRespondentContext): RespondentDecision {
	if (context.hasSubmission) {
		return { kind: 'continue', nin: null, preserveDateOfBirth: false };
	}
	if (context.isRepresenting) {
		return context.urlNin ? { kind: 'conflict' } : { kind: 'continue', nin: null, preserveDateOfBirth: false };
	}
	if (context.urlNin) {
		return context.allowRepresentative ? { kind: 'continue', nin: context.urlNin, preserveDateOfBirth: false } : { kind: 'conflict' };
	}
	if (context.preserveSubject) {
		return { kind: 'continue', nin: context.storedNin || null, preserveDateOfBirth: true };
	}
	return context.featureUseRepresentatives && (context.allowRepresentative || context.hasRepresentablePatients)
		? { kind: 'select' }
		: { kind: 'continue', nin: null, preserveDateOfBirth: false };
}
